/**
 * Issue #7 / #8 — 浏览器落盘工具。
 *
 * 本仓此前没有任何前端下载能力（无 blob / createObjectURL / Content-Disposition 处理），
 * 这里补齐唯一入口：拿到后端已校验过的 Blob 后触发浏览器下载并**立即回收 object URL**
 * （不回收会一直占着内存直到页面卸载）。
 *
 * 红线：这里只负责落盘，绝不负责「造数据」——文件内容一律来自真实后端导出接口
 * （ApiClient.download 已强制校验 HTTP 状态与 content-type），前端不得用当前页 state
 * 拼出一个假的导出文件。
 */

/** 触发浏览器下载一个已获取的 Blob，并回收临时 object URL。 */
export function triggerBrowserDownload(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  try {
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName;
    anchor.rel = 'noopener';
    // 必须入文档树才能在部分浏览器（Firefox）里可靠触发点击。
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
  } finally {
    // 同步 revoke 在 Chrome/Firefox/Safari 上都能在下载启动之后安全执行。
    URL.revokeObjectURL(url);
  }
}
